import { connect } from 'react-redux';
import Wrapper from './component';
import {
    clearError,
    clearLoaders,
    logout
} from './actions'
import {
    stopTime,
    startTime,
    updateDisposition
} from '../../utils/functions';

const mapStateToProps = (state, ownProps) => {
    return {
        ...state.wrapperReducer,
        ...state.loginReducer,
        ...state.systemDashboardReducer
    }
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        clearError: () => dispatch(clearError()),
        clearLoaders: () => dispatch(clearLoaders()),
        logout: () => dispatch(logout()),
        startTime: (comp, loc, id, data) => dispatch(startTime(comp, loc, id ,data)),
        stopTime: (comp, loc, id, data) => dispatch(stopTime(comp, loc, id, data)),
        updateDisposition: (comp, id, disp) => dispatch(updateDisposition(comp, id, disp))
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Wrapper);